<template>
  <in-viewport>
    <div class="links-section">
      <base-layout hide-sidebar>
        <border-box slot="sidebar"><h2 v-html="heading"/></border-box>
        <div slot="content">
          <border-box>
            <ul class="links-section__list">
              <li v-for="(link, i) in links" :key="i">
                <a
                  :href="link.href"
                  class="links-section__link"
                  target="_blank"
                >
                  {{ link.title }}
                </a>
              </li>
            </ul>
          </border-box>
        </div>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    BaseLayout,
    BorderBox
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    links: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
  .links-section {
    @include vertical-space((bottom: 2));

    &__list {
      @include reset-list;
    }

    &__link {
      @include reset-link;
      @include text(big, bold);
      transition: color $base-transition;

      &:hover {
        @include theme-opposite(color);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Contact/LinksSection.vue